import React from 'react';
import { Link } from 'react-router-dom';

const Landing = () => {
  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '1rem', color: '#1f2937' }}>
        🎉 Welcome to EventHub
      </h1>
      <p style={{ fontSize: '1.25rem', color: '#6b7280', marginBottom: '2rem', maxWidth: '600px' }}>
        Create, manage, and RSVP to events all in one place. 
        Connect with friends and never miss an important gathering!
      </p>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <Link 
          to="/signup" 
          style={{
            backgroundColor: '#6366f1',
            color: 'white',
            padding: '1rem 2rem',
            borderRadius: '8px',
            textDecoration: 'none',
            fontSize: '1.1rem',
            fontWeight: 'bold'
          }}
        >
          Get Started
        </Link>
        <Link 
          to="/login" 
          style={{
            backgroundColor: 'white',
            color: '#6366f1',
            padding: '1rem 2rem',
            borderRadius: '8px',
            textDecoration: 'none',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            border: '2px solid #6366f1'
          }}
        >
          Login
        </Link>
      </div>
      
      <div style={{
        marginTop: '4rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '2rem',
        maxWidth: '1000px',
        width: '100%'
      }}>
        <div style={{ padding: '1.5rem', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
          <h3 style={{ color: '#6366f1', marginBottom: '0.5rem' }}>📅 Create Events</h3>
          <p style={{ color: '#6b7280' }}>Easily create and manage your events with all the details</p>
        </div>
        <div style={{ padding: '1.5rem', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
          <h3 style={{ color: '#6366f1', marginBottom: '0.5rem' }}>✅ RSVP System</h3>
          <p style={{ color: '#6b7280' }}>Track who's coming and manage your guest list</p>
        </div>
        <div style={{ padding: '1.5rem', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
          <h3 style={{ color: '#6366f1', marginBottom: '0.5rem' }}>☁️ Weather Info</h3>
          <p style={{ color: '#6b7280' }}>Check weather forecasts for your event dates</p>
        </div>
      </div>
    </div>
  );
};

export default Landing;